module.exports = "../../../../platform/assets/pageMainIcon/youth_yewushezhilei8.svg";